export function OutlineMapIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3582 3C7.12136 3 4.86536 9.10561 7.95176 12.576L9.37257 14.0016L9.54057 14.1696L12.3582 17.0016L15.1854 14.1696L16.6542 12.7008C19.8846 9.24961 17.643 3 12.3582 3ZM12.3534 6.29281C13.7166 6.29281 14.8254 7.40161 14.8254 8.76481C14.8254 10.128 13.7166 11.2368 12.3534 11.2368C10.9902 11.2368 9.88137 10.128 9.88137 8.76481C9.88137 7.40161 10.9902 6.29281 12.3534 6.29281Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M14.1033 10.5116C15.0687 9.54627 15.0687 7.98108 14.1033 7.0157C13.1379 6.05032 11.5727 6.05032 10.6073 7.0157C9.64197 7.98108 9.64197 9.54627 10.6073 10.5116C11.5727 11.477 13.1379 11.477 14.1033 10.5116Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M14.1033 10.5116C15.0687 9.54627 15.0687 7.98108 14.1033 7.0157C13.1379 6.05032 11.5727 6.05032 10.6073 7.0157C9.64197 7.98108 9.64197 9.54627 10.6073 10.5116C11.5727 11.477 13.1379 11.477 14.1033 10.5116Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.7037 21.0004H5.99806C4.67325 21.0004 3.71325 19.7284 4.07805 18.4564L4.93726 15.4468C5.18206 14.5924 5.96446 14.002 6.85726 14.002H9.37246L9.54046 14.17L12.3581 17.002L15.1853 14.17L15.3533 14.002H17.8445C18.7373 14.002 19.5197 14.5924 19.7645 15.4468L20.6237 18.4564C20.9885 19.7284 20.0333 21.0004 18.7037 21.0004Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
